import { useQuery } from "@tanstack/react-query";
import { getPublicacoes } from "../../../api";
import { useEffect } from "react";
import { AxiosError } from "axios";
import { useRouter } from "next/navigation";

const useGetPublicacoes = (
    busca: string = "",
    categoriasIds: number[] = [],
    subcategoriasIds: number[] = [],
    editorasIds: number[] = [],
    notas: number[] = [],
    ordenacao: number = 1,
    pagina: number = 1,
    quantidade: number = 10,
    produtoId: number = 1
) => {
    const router = useRouter();

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["get_publicacoes", busca, categoriasIds, subcategoriasIds, editorasIds, notas, ordenacao, pagina],
        queryFn: () =>
            getPublicacoes(
                busca,
                categoriasIds,
                subcategoriasIds,
                editorasIds,
                notas,
                ordenacao,
                pagina,
                quantidade,
                produtoId
            ),
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (isError && error) {
            const axiosError = error as AxiosError;
            const status = axiosError?.response?.status;

            if (status === 404) {
                router.push("/ErroPage404");
            } else if (status === 500) {
                router.push("/ErroPage500");
            } else if (status === 401 || status === 403) {
                router.push("/ErroPage400");
            } else {
                router.push("/ErroPage");
            }
        }
    }, [isError, error, router]);

    return {
        data,
        isLoading,
        isError,
        error,
    };
};

export default useGetPublicacoes;
